import React from 'react';
import { UrlUtils } from 'PMT/utils';
import SessionStore from 'stores/SessionStore';

export default class RedirectPage extends React.Component {
  constructor(props) {
    super(props);

    const dataQueryParam = UrlUtils.getQueryParam('data');

    // - domainId
    // -restaurantId
    // - redirectTo
    const data = JSON.parse(window.atob(dataQueryParam));

    SessionStore.saveRestaurantsGroupId(data.restaurantsGroupId);
    SessionStore.saveRestaurantId(data.restaurantId);
    SessionStore.saveProDomainId(data.domainId);

    window.location = data.redirectTo;
  }

  render() {
    return <p>Redirecting...</p>;
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/other/RedirectPage.js